import React from 'react';
import PropTypes from 'prop-types';

import ProfileCircle from '../../common/profile/ProfileCircle';
import { getTextColor } from '../scheduleHelpers';

const initialsFor = (name = '') => {
  const parts = name.split(' ').filter(Boolean);
  if (!parts.length) return '';
  return `${parts[0][0] || ''}${parts.length > 1 ? parts[parts.length - 1][0] : ''}`.toUpperCase();
};

export default function UserRowAvatar({ row, className }) {
  const { name, scheduleColor } = row;
  return (
    <ProfileCircle
      radius={16}
      fontSize={11}
      initials={initialsFor(name)}
      className={className}
      style={scheduleColor ? { backgroundColor: scheduleColor } : {}}
      accentColor={scheduleColor ? getTextColor(scheduleColor) : undefined}
    />
  );
}

UserRowAvatar.propTypes = {
  row: PropTypes.shape({
    name: PropTypes.string,
    scheduleColor: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
};

UserRowAvatar.defaultProps = {
  className: undefined,
};
